// react-redux-form setup for marketing site

import { createForms } from "react-redux-form";

const defaultEnquiryForm: Forms.EnquiryForm = {
  account: {
    hasAccount: false,
    isShowingPasswords: false,
    marketingOptIn: false,
    phoneOptIn: false,
    firstName: null,
    lastName: null,
    phoneNumber: null,
    email: null,
    password: null,
    passwordConfirmation: null,
  },
  budget: {},
  travelDate: {},
  themes: {},
  travellers: {},
  independenceLevel: null,
  planningStage: null,
  currencyId: null,
  tripType: null,
  recommendedBy: null,
  location: null,
  notes: null,
} as Forms.EnquiryForm;

export const formModels = {
  enquiry: defaultEnquiryForm,
};
